// extracted by mini-css-extract-plugin
export var accountsEntitlementsControlHeader = "accounts-entitlements__control-header_WYuJTtEu_M7FHdzvhECB";
export var accountsEntitlementsLoadingContainer = "accounts-entitlements__loading-container_CHfZzSR4Wa_xkLbk_qDJ";
export var accountsEntitlementsTools = "accounts-entitlements__tools_jmImcK2NQDRHMYngIR1p";